/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

import type { GetSearchResultsResponse, SearchResultItem } from './search-api.types';

export async function getSearchResults(
    searchParams: URLSearchParams,
    signal?: AbortSignal
) {
    return axios
        .get<GetSearchResultsResponse>(`/api/search`, {
            params: searchParams,
            signal,
        })
        .then((response) => {
            return response.data;
        });
}

export async function getMultipleSearchResults({
    signal,
    requestParams,
}: {
    signal: AbortSignal;
    requestParams: URLSearchParams[];
}) {
    const results = await Promise.all(
        requestParams.map(async (params) => {
            return getSearchResults(params, signal);
        })
    );

    const combinedResults = results
        .flatMap((result) => result.results ?? [])
        .filter((result) => !!result.preview_image_url);

    const dedupedResultsMap = new Map<string, SearchResultItem>();
    for (const result of combinedResults) {
        if (result.entity_id && !dedupedResultsMap.has(result.entity_id)) {
            dedupedResultsMap.set(result.entity_id, result);
        }
    }
    const dedupedResults = Array.from(dedupedResultsMap.values());

    return dedupedResults.slice(0, 10);
}
